module.exports = __webpack_public_path__ + "img/percentage.36cc767a.svg";